import React, { useEffect, useState } from 'react';
import { adminAPI } from '../services/api';

function Subscriptions() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const res = await adminAPI.getSubscriptionPlans();
      setPlans(res.data.plans || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load subscription plans');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="text-center py-12">Loading...</div>;
  if (error) return <div className="bg-red-50 border-2 border-red-200 text-red-700 px-4 py-3 rounded-lg">{error}</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-4xl font-bold text-gray-900">Subscription Plans</h1>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {plans.map((plan, idx) => (
          <div key={idx} className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name || 'StrapIn Pro'}</h3>
            <p className="text-gray-600 mb-4">{plan.description || 'Premium features'}</p>
            <div className="space-y-3">
              {plan.pricing ? (
                Object.entries(plan.pricing).map(([key, value]) => (
                  value ? (
                    <div key={key} className="flex justify-between">
                      <span className="text-gray-600 font-semibold capitalize">{key}</span>
                      <span className="font-bold text-gray-900">
                        {value.currency || '$'}{value.amount || value.price || 0}
                      </span>
                    </div>
                  ) : null
                ))
              ) : (
                <div className="text-gray-500 text-sm">No pricing data</div>
              )}
            </div>
            {plan.features && plan.features.length > 0 && (
              <div className="mt-4">
                <p className="font-semibold text-gray-900 mb-2">Features:</p>
                <ul className="list-disc list-inside text-gray-600 space-y-1">
                  {plan.features.map((f, i) => (
                    <li key={i}>{f.name || f.label || f.description || 'Feature'}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Subscriptions;

